<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <!-- <div class="search-path">
                                    <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter"
                                        :class="{ setclose: filter }">
                                        <img src="@/assets/img/icons/filter.svg" alt="img" />
                                        <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
                                    </a>
                                </div> -->
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="wordset">
                                <ul>
                                    <li>

                                        <div class="d-flex flex-column justify-content-center align-items-center ">

                                            <a href="javascript:void(0);" @click="exportExcel()"><img
                                                    src="../../../assets/img/icons/excel.svg" alt="img" /></a>
                                            <span style="font-size: 10px; margin-top: -8px;">excel</span>
                                        </div>

                                    </li>
                                    <!-- <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"><img
                                                src="@/assets/img/icons/pdf.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"><img
                                                src="@/assets/img/icons/excel.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"><img
                                                src="@/assets/img/icons/printer.svg" alt="img" /></a>
                                    </li> -->
                                </ul>
                            </div>
                        </div>
                        <!-- /Filter -->
                        <!-- <div class="card mb-0" id="filter_inputs" :style="{
                            display: filter ? 'block' : 'none',
                        }">
                            <div class="card-body pb-0">
                                <div class="row">
                                    <div class="col-lg-12 col-sm-12">
                                        <div class="row">
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Product" placeholder="Choose Product" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Choose" placeholder="Choose Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Category" placeholder="Choose Sub Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Brand" placeholder="Brand" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Price" placeholder="Price" />
                                                </div>
                                            </div>
                                            <div class="col-lg-1 col-sm-6 col-12">
                                                <div class="form-group">
                                                    <a class="btn btn-filters ms-auto"><img
                                                            src="@/assets/img/icons/search-whites.svg" alt="img" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- /Filter -->
                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="filteredData" @change="onChange">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>

                                    

                                    <!-- <template v-else-if="column.key === 'action'">
                                        
                                        <div class="d-flex align-items-center ">
                                            <router-link class="me-3 text-secondary fs-5 " to="customerhistory"
                                                @click="edit(record);">
                                                <MDBIcon icon="history" />
                                            </router-link>
                                            <router-link class="me-3" to="editcustomer" @click="edit(record);">
                                                <img src="@/assets/img/icons/edit.svg" alt="img" />
                                            </router-link>
                                            <a class="confirm-text" href="javascript:void(0);"
                                                @click="terminate(record.id, record.fullname); showModal('terminate');">
                                                <img src="@/assets/img/icons/delete.svg" alt="img" />
                                            </a>
                                        </div>
                                    </template> -->
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        Are u sure want to delete this data?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('terminate')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

import Cookies from "js-cookie";
import axios from "axios";
import { MDBIcon } from "mdb-vue-ui-kit";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, rupiah, AlertBottom, openInNewTab } from "@/assets/js/function";

export default {
    components: {
        MDBIcon,
    },
    data() {
        return {
            filter: false,
            title: "Customer Feedback",
            title1: "Manage Customer Feedback",
            // items: [
            //     {
            //         text: "Add New Customer",
            //         addname: "/addcustomer",
            //     },
            // ],

            //data
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Invoice Date",
                    dataIndex: "invoice_date",
                    key: "invoice_date",
                    sorter: {
                        compare: (a, b) => {
                            a = a.invoice_date.toLowerCase();
                            b = b.invoice_date.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "No. Invoice",
                    dataIndex: "invoice_no",
                    key: "invoice_no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.invoice_no.toLowerCase();
                            b = b.invoice_no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Rating 1",
                    dataIndex: "rating1",
                    key: "rating1",
                    sorter: {
                        compare: (a, b) => {
                            a = a.rating1.toLowerCase();
                            b = b.rating1.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Rating 2",
                    dataIndex: "rating2",
                    key: "rating2",
                    sorter: {
                        compare: (a, b) => {
                            a = a.rating2.toLowerCase();
                            b = b.rating2.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Rating 3",
                    dataIndex: "rating3",
                    key: "rating3",
                    sorter: {
                        compare: (a, b) => {
                            a = a.rating3.toLowerCase();
                            b = b.rating3.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Rating 4",
                    dataIndex: "rating4",
                    key: "rating4",
                    sorter: {
                        compare: (a, b) => {
                            a = a.rating4.toLowerCase();
                            b = b.rating4.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Rating 5",
                    dataIndex: "rating5",
                    key: "rating5",
                    sorter: {
                        compare: (a, b) => {
                            a = a.rating5.toLowerCase();
                            b = b.rating5.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Message",
                    dataIndex: "saran",
                    key: "saran",
                    sorter: {
                        compare: (a, b) => {
                            a = a.saran.toLowerCase();
                            b = b.saran.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                    customCell: () => {
                        return {
                            style: {
                                whiteSpace: "normal",   // allow wrapping
                                wordBreak: "break-word" // break long words if needed
                            }
                        };
                    },
                },
                


                // {
                //     title: "Action",
                //     key: "action",
                //     sorter: false,
                // },
            ],

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            nama_terminate: "",

            //filter
            query: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        this.index();
    },

    computed: {
        filteredData() {

            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {
                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison

            return this.data.filter(item =>
                (item.invoice_date || '').toLowerCase().includes(lowerCaseQuery) ||
                (item.invoice_no || '').toLowerCase().includes(lowerCaseQuery) ||
                (item.saran || '').toLowerCase().includes(lowerCaseQuery)
            );
        }
    },
    methods: {
        rupiah,
        show_izitoast() {
            AlertBottom('tessst');
        },
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },
        exportExcel() {

            ShowLoading();
            // let formData = new FormData();

            // Object.entries(this.currentData).forEach(([key, value]) => {
            //     // Create a new Date object
            //     const date = new Date(value);

            //     // Use built-in methods to get year, month, and day
            //     const year = date.getFullYear();
            //     const month = String(date.getMonth() + 1).padStart(2, '0');
            //     const day = String(date.getDate()).padStart(2, '0');
            //     const formattedDate = `${year}-${month}-${day}`;
            //     formData.append(key, formattedDate);
            // });

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'customer_feedback_export';
            } else {
                this.api = base_url + 'customer_feedback_export';
            }
            axios
                .post(this.api, '', this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        openInNewTab(response.data.data.file_report);
                        CloseLoading();
                    }


                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    ErrorConnectionTimeOut(error);
                });

        },

        index() {
            ShowLoading();

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'customer_feedback';
            } else {
                this.api = base_url + 'customer_feedback';
            }
            axios
                .post(this.api, '', this.config)
                .then((response) => {
                    console.log(response)
                    if (response.data.status == true) {
                        this.data = [];
                        const feedback = response.data.data
                        console.log('ini feedback', feedback)

                        // feedback.forEach((item, index) => {
                        //     let item_prepare = { ...item, no: (index + 1), };
                        //     this.data.push(item_prepare);
                        // });

                        if (Array.isArray(feedback)) {
                        feedback.forEach((item, index) => {
                            this.data.push({ ...item, no: index + 1 });
                        });
                        } else {
                        // handle single object case
                        this.data.push({ ...feedback, no: 1 });
                        }


                        CloseLoading();
                    }


                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    ErrorConnectionTimeOut(error);
                });

        },
        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
        },
        delete2() {
            ShowLoading();
            let formData = new FormData();
            formData.append("id", this.id_terminate);
            formData.append("nama", this.nama_terminate);

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'customer_delete';
            } else {
                this.api = base_url + 'customer_delete';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        const index = this.data.findIndex((record) => record.id === this.id_terminate);
                        this.data.splice(index, 1);
                        CloseLoading();
                        AlertBottom(response.data.message);
                        this.hideModal2('terminate');
                    }
                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {

                    ErrorConnectionTimeOut(error);
                });


        },
        terminate(id, nama) {
            this.id_terminate = id;
            this.nama_terminate = nama;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>

<style>
.ant-tooltip {
    display: none !important;
}
</style>